import { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Button, Drawer } from 'antd';
import Icon from '@components/Icon';
import stores from '@stores';
import Logo from './Logo';
import LanguageSwitcher from '@components/LanguageSwitcher';
import { isRtlLanguage } from '@i18n/config';

export default observer(({headLeft, headRight}) => {
    const { t: tCommon, i18n } = useTranslation('common');
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [fromVideoCapture, setFromVideoCapture] = useState(false);
    const isRtl = isRtlLanguage(i18n.language);
    
    // 检查是否来自视频截图页面
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        setFromVideoCapture(urlParams.get('source') === 'videoCapture');
    }, []);
    
    const handleSetTheme = () => {
        stores.editor.setTheme()
        localStorage.setItem('SHOTEASY_BEAUTIFIER_THEME', stores.editor.theme);
    }
    
    // 处理返回功能
    const handleBackToHome = (e) => {
        e.preventDefault();
        
        // 清除编辑状态
        if (stores.editor.clearFun) {
            stores.editor.clearFun();
        }
        
        // 如果来自视频截图，返回到视频截图页面
        if (fromVideoCapture) {
            window.location.href = '/video-capture?from=editor';
        } else {
            // 使用URL参数来控制，返回到首页
            const url = new URL(window.location);
            url.searchParams.delete('editor');
            window.history.pushState({}, '', url);
            window.location.reload(); // 强制刷新页面返回着陆页
        }
    }
    
    const NavItems = () => (
        <>
            <a 
                href={fromVideoCapture ? '/video-capture' : '/'} 
                onClick={handleBackToHome}
                className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2 md:py-0"
            >
                <Icon.Home size={16} className="mr-1" />
                {fromVideoCapture ? tCommon('backToVideoCapture') : tCommon('home')}
            </a>
            <a 
                href="/quick-start" 
                onClick={(e) => {
                    e.preventDefault();
                    window.open('/quick-start', '_blank');
                }}
                className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2 md:py-0"
            >
                <Icon.BookOpen size={16} className="mr-1" />
                {tCommon('quickStart')}
            </a>
            <a 
                href="/about"
                onClick={(e) => {
                    e.preventDefault();
                    window.open('/about', '_blank');
                }}
                className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2 md:py-0"
            >
                <Icon.Info size={16} className="mr-1" />
                {tCommon('about')}
            </a>
            <LanguageSwitcher />
            <Button
                type="text"
                shape='circle'
                icon={stores.editor.isDark ? <Icon.Moon size={16} /> : <Icon.Sun size={16} />}
                onClick={handleSetTheme}
                className="ml-2"
            />
        </>
    );
    
    return (
        <div className='flex items-center justify-between shrink-0 bg-white dark:bg-gray-900 py-3 px-5 border-b border-b-gray-50 dark:border-b-gray-700 shadow-sm relative z-[11] select-none'>
            <div className="flex items-center">
                {headLeft ? headLeft : <Logo />}
            </div>
            
            <nav className="hidden md:flex items-center space-x-6">
                <NavItems />
            </nav>
            
            <div className="md:hidden">
                <Button
                    type="text"
                    shape='circle'
                    icon={<Icon.Menu size={20} />}
                    onClick={() => setMobileMenuOpen(true)}
                    className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                />
            </div>
            
            {/* 移动设备导航菜单 */}
            <Drawer
                title={tCommon('navigation')}
                placement={isRtl ? 'left' : 'right'}
                onClose={() => setMobileMenuOpen(false)}
                open={mobileMenuOpen}
                width={250}
            >
                <div className="flex flex-col space-y-4">
                    <NavItems />
                </div>
            </Drawer>
        </div>
    );
}); 